import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useNavigate, useParams } from 'react-router-dom';
import { DASHBOARD_ROUTE } from '../../../../constants/RouteNameConstants';
import WestRoundedIcon from '@mui/icons-material/WestRounded';
import { useDispatch, useSelector } from 'react-redux';
import { CustomTooltips } from '../../../../components';
import {
  checkForceUnclaimRequest,
  editorDocumentRequest,
  vendorCompleteParagraphRequest,
  vendorDetailsRequest,
} from '../../Editor/actions';
import MoreHorizOutlinedIcon from '@mui/icons-material/MoreHorizOutlined';
import Timer from '../../Editor/component/Timer';
import KeyboardShortcutsModal from '../modal/keyboardShortcutsModal';
import MoreModal from '../modal/moreModal';
import { Box, Stack, Tooltip } from '@mui/material';
import FindAndReplaceModal from '../modal/findAndReplaceModal';
import DocumentsOptionModal from '../modal/documentsOptionModal';
import UnclaimModal from '../modal/unclaimModal';
import CachedOutlinedIcon from '@mui/icons-material/CachedOutlined';
import saveCloud from '../../../../assets/images/saveCloud.svg';
import half_timer_icon from '../../../../assets/images/half-timer.svg';
import SearchIcon from '@mui/icons-material/Search';

import command_icon from '../../../../assets/images/command-icon.svg';
import document_icon from '../../../../assets/images/document-icon.svg';
import question_box_icon from '../../../../assets/images/question-box-icon.svg';
import guidelines_pdf from '../../../../assets/pdf/Datagain_Style_Guide.pdf';
import { CustomButton } from '../../../../components/mui/CustomButton';
import { saveSlateDataRequest, updateSlateSelectedNode } from '../actions/saveSlateDataActions';
import { truncateString } from '../../../../utils/TruncateStringUtils';
import { getTimeFromTimestamp } from '../../../../utils/getTimeFromTimestamp';
import CustomTooltip from '../../../../components/CustomTooltips';
import ProofreaderSubmitModal from '../modal/ProofreaderSubmitModal';
import useKeyPress from '../../../../hook/useKeyPress';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { getUserInfo } from '../../../../utils/UserInfoUtils';
import { getLegalTemplateFormFieldDetailsRequest, getLegalTemplateFormFieldDetailsSuccess, updateCompletedByIndex } from '../actions/slateDataActions';
import { Editor, Transforms } from 'slate';
import LegalInfoUtahModal from '../modal/LegalInfoUtahModal';
import ReworkStatusModal from '../modal/ReworkStatusModal';

const TopSection = ({
  handleUndo,
  handleRedo,
  editor,
  isEditorReady = true,
  usePreviousPath,
  todayWorkClick,
  setTodayWorkClick,
  setIsSidebarOpen,
  isUndoDisabled,
  isRedoDisabled,
  setFilterApiCall,
}) => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const navigate = useNavigate();
  const { lastSavedTime, loading: slateDataLoading } = useSelector((state) => state.saveSlateData);
  const legalTemplateFormFieldDetails = useSelector((state) => state?.settings?.legalTemplateFormFieldDetails);
  const { data, completedPercentage, loading, isDirty, selectedNode, notCompletedNodes } = useSelector(
    (state) => state.slateData,
  );
  let dashboardWidgetData = useSelector((state) => state?.totalCounts?.user?.data?.value);
  let dashboardData = dashboardWidgetData && JSON.parse(dashboardWidgetData);
  let editorDetails = useSelector((state) => state?.editorDetails?.user?.data?.value);
  let editorDetailsData = editorDetails && JSON.parse(editorDetails);
  let editorDetailsLoading = useSelector((state) => state?.editorDetails?.loading);
  let vendorDetail = useSelector((state) => state?.vendorDetils?.user?.data?.value);
  let vendorDetailData = vendorDetail && JSON.parse(vendorDetail);
  const allowEdit = editorDetailsData?.Status !== 'Rework';
  const [findReplaceShow, setFindReplaceShow] = useState(false);
  const [keyboardShortcutsShow, setKeyboardShortcutsShow] = useState(false);
  const [documentsShow, setDocumentsShow] = useState(false);
  const [moreShow, setMoreShow] = useState(false);
  const [unclaimShow, setUnclaimShow] = useState(false);
  const [warningShow, setWarningShow] = useState(usePreviousPath === true && todayWorkClick === true ? true : false);
  const [percentage, setPercentage] = useState(0);
  const [submitShow, setSubmitShow] = useState(false);
  const [legalInfoUtahModal, setLegalInfoUtahModal] = useState(false);
  const [reworkStatusModal, setReworkStatusModal] = useState(false);

  const userInfo = getUserInfo();

  // Track editor readiness for debugging
  const [isEditorAvailable, setIsEditorAvailable] = useState(!!editor);

  useEffect(() => {
    setIsEditorAvailable(!!editor);
    if (editor) {
      console.log('Editor is now available');
    }
  }, [editor]);

  // Simple handlers without unnecessary stopPropagation
  const handleKeyboardShortcutsOpenModal = () => {
    setKeyboardShortcutsShow(true);
  };

  const handleKeyboardShortcutsCloseModal = () => setKeyboardShortcutsShow(false);

  const handleFindReplaceOpenModal = () => {
    if (!allowEdit) return;
    if (!editor) {
      console.warn('Find & Replace clicked but editor is not available');
      toast.error('Editor is not ready yet. Please try again in a moment.');
      return;
    }
    setFindReplaceShow(true);
  };

  const handleFindReplaceCloseModal = () => setFindReplaceShow(false);

  const handleDocumentsOpenModal = () => {
    dispatch(editorDocumentRequest(id));
    setDocumentsShow(true);
  };

  const handleDocumentsCloseModal = () => setDocumentsShow(false);

  const handleMoreShowOpenModal = () => {
    setMoreShow(true);
  };

  const handleMoreShowCloseModal = () => setMoreShow(false);

  const handleUnclaimOpenModal = () => {
    setUnclaimShow(true);
  };

  const unclaimHideModal = () => setUnclaimShow(false);

  let isSaveTranscript = useSelector((state) => state?.VendorSaveTranscriptParagraphFile?.loading);

  const handleWarningCloseModal = () => {
    setWarningShow(false);
    setTodayWorkClick(false);
  };

  // Keyboard shortcut for find & replace
  useEffect(() => {
    if (editor) {
      const keyPressHandler = (e) => {
        if ((e.ctrlKey || e.metaKey) && e.shiftKey && e.key === 'f') {
          e.preventDefault();
          handleFindReplaceOpenModal();
        }
        if (e.metaKey && e.key === 'y') {
          e.preventDefault();
          handleRedo();
        }
      };

      window.addEventListener('keydown', keyPressHandler);
      return () => window.removeEventListener('keydown', keyPressHandler);
    }
  }, [editor]);

  useEffect(() => {
    setWarningShow(usePreviousPath === true && todayWorkClick === true);
  }, [usePreviousPath, todayWorkClick]);

  const handleBackToHome = () => {
    // navigate(DASHBOARD_ROUTE);
    if (slateDataLoading) {
      toast('Please wait, your transcript is being saved...', {
        icon: '⚠️',
        position: 'top-center',
        style: {
          background: '#f0ad4e',
          color: '#fff',
          width: '450px',
        },
      });
    } else if (isDirty) {
      toast('Please wait, your transcript is being saved...', {
        icon: '⚠️',
        position: 'top-center',
        style: {
          background: '#f0ad4e',
          color: '#fff',
          width: '450px',
        },
      });
      dispatch(saveSlateDataRequest({ audioFileId: id, transcriptJSON: JSON.stringify({ data: data }) }));
      dispatch(
        vendorCompleteParagraphRequest({
          userId: userInfo?.UserId,
          audioFileId: id,
          isVendor: false,
          totalParagraphs: data?.length,
          completedParagraphs: data?.filter((i) => i.completed)?.length,
        }),
      );
    } else navigate(DASHBOARD_ROUTE);
  };

  const handlePopState = (e) => {
    e.preventDefault();
    // Block navigation if save is in progress
    if (isDirty) {
      if (window.confirm('Do you want to go back ?')) {
        navigate(DASHBOARD_ROUTE);
      } else {
        dispatch(saveSlateDataRequest({ audioFileId: id, transcriptJSON: JSON.stringify({ data: data }) }));
        window.history.pushState(null, '', window.location.pathname);
      }
    }
  };

  const handleBeforeUnload = (e) => {
    if (isDirty) {
      dispatch(saveSlateDataRequest({ audioFileId: id, transcriptJSON: JSON.stringify({ data: data }) }));
      const message = 'You have unsaved changes. Do you really want to leave?';
      e.returnValue = message;
      return message;
    }
  };

  useEffect(() => {
    window.history.pushState(null, null, window.location.pathname);

    window.addEventListener('popstate', handlePopState);
    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('popstate', handlePopState);
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [isDirty]);

  useEffect(() => {
    const calculatePercentage = () => {
      const staffDate = new Date(dashboardData && dashboardData?.todaysFile?.StaffDueDate);
      const due = new Date(dashboardData && dashboardData?.todaysFile?.DueDate);
      const now = new Date();

      const difference1 = due - staffDate;
      const difference2 = now - staffDate;

      if (difference1 > 0 && difference2 >= 0) {
        const elapsedPercentage = (difference2 * 100) / difference1;
        setPercentage(Math.min(elapsedPercentage, 100));
      } else {
        setPercentage(0);
      }
    };
    calculatePercentage();

    const timer = setInterval(calculatePercentage, 1000);
    return () => clearInterval(timer);
  }, []);

  const handleSave = () => {
    dispatch(
      checkForceUnclaimRequest({
        claimId: editorDetailsData?.claimId,
        userId: userInfo?.UserId,
      }),
    );
    dispatch(saveSlateDataRequest({ audioFileId: id, transcriptJSON: JSON.stringify({ data: data }) }));
    dispatch(
      vendorCompleteParagraphRequest({
        userId: userInfo?.UserId,
        audioFileId: id,
        isVendor: false,
        totalParagraphs: data?.length,
        completedParagraphs: data?.filter((i) => i.completed)?.length,
      }),
    );
  };

  const handleSubmitOpenModal = () => {
    if (isDirty) {
      toast('Please wait, your transcript is being saved...', {
        icon: '⚠️',
        position: 'top-center',
        style: {
          background: '#f0ad4e',
          color: '#fff',
          width: '450px',
        },
      });
      handleSave();
    } else if (id === null) {
      navigate(DASHBOARD_ROUTE);
    } else {
      dispatch(
        vendorDetailsRequest({
          audioFileId: id,
          userId: editorDetailsData?.VendorId,
        }),
      );
      setSubmitShow(true);
    }
  };

  const onNextCheckbox = (e) => {
    e?.stopPropagation();
    e?.preventDefault();
    if (typeof selectedNode !== 'number') {
      if (notCompletedNodes.length > 0) {
        dispatch(updateSlateSelectedNode(notCompletedNodes[0]));
      }
      return;
    }

    const currentIndexInList = notCompletedNodes.indexOf(selectedNode);
    if (currentIndexInList !== -1) {
      const nextIndex = (currentIndexInList + 1) % notCompletedNodes.length;
      dispatch(updateSlateSelectedNode(notCompletedNodes[nextIndex]));
    } else {
      const next = notCompletedNodes.find((i) => i > selectedNode);
      if (typeof next === 'number') {
        dispatch(updateSlateSelectedNode(next));
      } else {
        dispatch(updateSlateSelectedNode(notCompletedNodes[0]));
      }
    }
  };

  const onPrevCheckbox = (e) => {
    e?.stopPropagation();
    e?.preventDefault();

    if (typeof selectedNode !== 'number') {
      if (notCompletedNodes.length > 0) {
        dispatch(updateSlateSelectedNode(notCompletedNodes[0]));
      }
      return;
    }
    const currentIndexInList = notCompletedNodes.indexOf(selectedNode);
    if (currentIndexInList !== -1) {
      const prevIndex = (currentIndexInList - 1 + notCompletedNodes.length) % notCompletedNodes.length;
      dispatch(updateSlateSelectedNode(notCompletedNodes[prevIndex]));
    } else {
      const prev = [...notCompletedNodes].reverse().find((i) => i < selectedNode);
      if (typeof prev === 'number') {
        dispatch(updateSlateSelectedNode(prev));
      } else {
        dispatch(updateSlateSelectedNode(notCompletedNodes[notCompletedNodes.length - 1]));
      }
    }
  };

  const handleCheckboxMark = (event) => {
    event?.stopPropagation();
    event?.preventDefault();
    if (!allowEdit) return;
    if (typeof selectedNode === 'number') {
      const path = [selectedNode];
      const nodeEntry = Editor.node(editor, path);
      if (!nodeEntry) return;
      const [node] = nodeEntry;
      const newCompleted = !node.completed;
      Transforms.setNodes(editor, { completed: newCompleted }, { at: path });
      dispatch(updateCompletedByIndex({ index: selectedNode, completed: newCompleted }));
      onNextCheckbox(event);
    }
  };

  useEffect(() => {
    if (
      editorDetailsData?.FileId &&
      editorDetailsData?.TemplateTrans !== 0 &&
      editorDetailsData?.TemplateTrans !== null
    ) {
      dispatch(
        getLegalTemplateFormFieldDetailsRequest({
          audioFileId: editorDetailsData.Id,
          legalTemplateName: editorDetailsData.TemplateTrans,
          cgaType: editorDetailsData?.TemplateTrans === 5 ? editorDetailsData?.CGAType : undefined,
        }),
      );
    } else {
      dispatch(
        getLegalTemplateFormFieldDetailsSuccess({}),
      );
    }
    if (editorDetailsData?.Status === 'Rework') {
      setReworkStatusModal(true);
    }
  }, [editorDetailsData?.FileId, editorDetailsData?.TemplateTrans, editorDetailsData?.CGAType]);

  const handleSubmitCloseModal = () => setSubmitShow(false);
  useKeyPress(handleFindReplaceOpenModal, 'f', true);
  useKeyPress(handleCheckboxMark, 'm', true, false);

  const totalNodes = data?.length || 0;
  const completedNodes = data?.filter((n) => n.completed)?.length || 0;

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          pt: '20px',
          pb: '18px',
          justifyContent: 'space-between',
          alignItems: 'center',
          position: 'relative', // Add this to ensure z-index works properly
        }}
      >
        {/* Back button section */}
        <Box
          sx={{
            cursor: 'pointer',
            paddingLeft: 3,
            zIndex: 5, // Higher z-index
            position: 'relative',
          }}
          onClick={handleBackToHome}
        >
          <Stack direction={'row'} alignItems={'center'} spacing={1}>
            <WestRoundedIcon />
            <Box
              sx={{
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                maxWidth: '260px',
              }}
            >
              <Tooltip title={editorDetailsData?.UserFileName ?? ''} placement="top">
                <span>
                  {truncateString(editorDetailsData?.UserFileName || editorDetailsData?.ProjectName || '', 35)}
                </span>
              </Tooltip>
            </Box>
            {slateDataLoading ? (
              <CustomTooltip title="saving">
                <span onClick={(e) => e.stopPropagation()}>
                  <CachedOutlinedIcon
                    sx={{
                      animation: 'spin 2s linear infinite',
                      height: '20px',
                      opacity: 0.7,
                      cursor: 'not-allowed',
                    }}
                  />
                </span>
              </CustomTooltip>
            ) : (
              <CustomTooltip title={`Last Saved ${getTimeFromTimestamp(lastSavedTime)}`}>
                <span
                  onClick={(e) => {
                    e.stopPropagation();
                    if (isDirty) {
                      handleSave();
                    }
                  }}
                  style={{
                    cursor: isDirty ? 'pointer' : 'not-allowed',
                    opacity: isDirty ? 1 : 0.5,
                  }}
                >
                  <img src={saveCloud} alt="last-save" />
                </span>
              </CustomTooltip>
            )}
          </Stack>
        </Box>

        {/* Middle section - toolbar */}
        <div
          className="transcript-options-button"
          style={{
            zIndex: 5,
            position: 'relative',
          }}
        >
          <ul className="tags-button-wrapper" style={{ display: 'flex', listStyle: 'none', padding: 0, margin: 0 }}>
            {/* Find & Replace */}
            {allowEdit && <li
              className="tags-button-item "
              style={{
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
              }}
              onClick={handleFindReplaceOpenModal}
            >
              <CustomTooltips title="Find & Replace" id="t-3" variant="primary">
                {/* <i className="icon-search-icon" style={{ display: 'block', fontSize: '18px' }}></i> */}
                <SearchIcon sx={{ color: '#2b2b67' }} />
              </CustomTooltips>
            </li>}

            {/* Shortcuts */}
            <li
              className="tags-button-item"
              style={{
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
              }}
              onClick={handleKeyboardShortcutsOpenModal}
            >
              <CustomTooltips title="Shortcuts" id="t-4" variant="primary">
                <img
                  src={command_icon}
                  className="img-fluid"
                  alt="command-icon"
                  style={{ height: '22px', width: '22px', display: 'block' }}
                />
              </CustomTooltips>
            </li>

            {/* Resources */}
            <li
              className="tags-button-item"
              style={{
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
              }}
              onClick={handleDocumentsOpenModal}
            >
              <CustomTooltips title="Resources" id="t-5" variant="primary">
                <img
                  src={document_icon}
                  className="img-fluid"
                  style={{ height: '19px', width: '19px', display: 'block' }}
                  alt="document-icon"
                />
              </CustomTooltips>
            </li>

            {/* Guidelines */}
            {!(editorDetailsData?.TemplateTrans !== 0 &&
              editorDetailsData?.TemplateTrans !== null && 
              legalTemplateFormFieldDetails?.isFormNeeded) 
              && (<li
              className="tags-button-item"
              style={{
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <CustomTooltips title="Transcription guidelines" id="t-6">
                <a href={guidelines_pdf} target="_blank" rel="noopener noreferrer" style={{ display: 'block' }}>
                  <img
                    src={question_box_icon}
                    className="img-fluid"
                    style={{ height: '19px', width: '19px', display: 'block' }}
                    alt="question_box-icon"
                  />
                </a>
              </CustomTooltips>
            </li>)}
            {/* Progressbar*/}
            {editorDetailsData && (
              <li
                className="tags-button-item"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <CustomTooltip title={`Progress: ${completedPercentage}%`}>
                  <span>
                    <img src={half_timer_icon} alt="half-timer" />
                  </span>
                </CustomTooltip>
              </li>
            )}

            {/* Legal Info */}
            {editorDetailsData?.TemplateTrans !== 0 &&
              editorDetailsData?.TemplateTrans !== null &&
              legalTemplateFormFieldDetails?.isFormNeeded && (
                <li
                  className="tags-button-item"
                  style={{ display: 'flex', alignItems: 'center' }}
                  onClick={() => setLegalInfoUtahModal(true)}
                >
                  <CustomTooltips title="Legal Info Details" id="t-7">
                    <div style={{ display: 'block' }}>
                      <StarBorderIcon sx={{ color: '#2b2b67' }} />
                    </div>
                  </CustomTooltips>
                </li>
              )}

            {/* More */}
            <li
              className="tags-button-item"
              style={{
                cursor: 'pointer',
                // padding: '8px 12px',
                display: 'flex',
                alignItems: 'center',
              }}
              onClick={handleMoreShowOpenModal}
            >
              <CustomTooltips variant="primary" title="More" id="t-7">
                <div style={{ display: 'block' }}>
                  <MoreHorizOutlinedIcon sx={{ color: '#2b2b67' }} />
                </div>
              </CustomTooltips>
            </li>
          </ul>
        </div>

        {/* Right section - Timer and Submit button */}
        <div
          className="transcript-right-button"
          style={{
            display: 'flex',
            alignItems: 'center',
            zIndex: 5,
            position: 'relative',
          }}
        >
          {editorDetailsLoading === false && editorDetailsData && (
            <Stack gap={1} direction={'row'} alignItems={'center'}>
              <CustomTooltips title="Navigate to the next unchecked checkbox" id="t-3" variant="primary">
                <ArrowUpwardIcon onClick={onPrevCheckbox} className="cursor-pointer" />
              </CustomTooltips>
              {completedNodes}/{totalNodes}
              <CustomTooltips title="Navigate to the next unchecked checkbox " id="t-3" variant="primary">
                <ArrowDownwardIcon onClick={onNextCheckbox} className="cursor-pointer" />
              </CustomTooltips>
            </Stack>
          )}
          {editorDetailsLoading === false && editorDetailsData && (
            <div
              style={{
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                marginRight: '10px',
              }}
              // onClick={handleUnclaimOpenModal}
            >
              <Timer setUnclaimShow={handleUnclaimOpenModal} />
            </div>
          )}

          <div style={{ position: 'relative', zIndex: 6 }}>
            <CustomButton
              variant="primary"
              className="w120 me-2"
              style={{
                cursor: 'pointer',
                position: 'relative',
                zIndex: 6,
              }}
              onClick={() => {
                if (isSaveTranscript) {
                  toast('Please wait, your transcript is being saved.', {
                    icon: '⚠️',
                    position: 'top-center',
                    style: {
                      background: '#f0ad4e',
                      color: '#fff',
                      width: '450px',
                    },
                  });
                } else {
                  if (
                    legalTemplateFormFieldDetails?.isFormNeeded && 
                    editorDetailsData?.TemplateTrans !== 0 &&
                    editorDetailsData?.TemplateTrans !== null &&
                    !legalTemplateFormFieldDetails?.isFormSubmitted
                  ) {
                    toast('Please submit the legal info before submitting the file.', {
                      icon: '⚠️',
                      position: 'top-center',
                      style: {
                        background: '#f0ad4e',
                        color: '#fff',
                        width: '450px',
                      },
                    });
                  } else {
                    handleSubmitOpenModal();
                  }
                }
              }}
              disabled={loading}
            >
              Submit
            </CustomButton>
          </div>
        </div>
      </Box>

      {/* Modals */}
      <KeyboardShortcutsModal
        handleKeyboardShortcutsCloseModal={handleKeyboardShortcutsCloseModal}
        keyboardShortcutsShow={keyboardShortcutsShow}
      />
      <MoreModal moreShow={moreShow} handleMoreShowCloseModal={handleMoreShowCloseModal} />

      {/* Only render FindAndReplaceModal if editor is ready */}
      {isEditorAvailable && findReplaceShow && (
        <FindAndReplaceModal open={findReplaceShow} onClose={handleFindReplaceCloseModal} editor={editor} />
      )}

      <DocumentsOptionModal open={documentsShow} onClose={handleDocumentsCloseModal} />
      <UnclaimModal open={unclaimShow} onClose={unclaimHideModal} setFilterApiCall={setFilterApiCall} />
      {/* <AlertModal open={warningShow} onClose={handleWarningCloseModal} percentage={percentage} /> */}

      {/* ProofreaderSubmitModal */}
      {submitShow && (
        <ProofreaderSubmitModal
          editorDetailsData={editorDetailsData}
          vendorDetailData={vendorDetailData}
          submitShow={submitShow}
          handleSubmitC
          handleSubmitCloseModal={handleSubmitCloseModal}
          setFilterApiCall={setFilterApiCall}
        />
      )}
      <LegalInfoUtahModal open={legalInfoUtahModal} onClose={() => setLegalInfoUtahModal(false)} />
      <ReworkStatusModal open={reworkStatusModal} onClose={() => setReworkStatusModal(false)} />
    </>
  );
};

export default TopSection;
